import * as React from 'react';
import { PropsWithChildren } from 'react';

import styled from 'styled-components';

import { TextWrapper } from './text-wrapper';

export const Label: React.FC<PropsWithChildren<NonNullable<unknown>>> = ({ children }) => {
	return (
		<Container>
			<TextWrapper>{children}</TextWrapper>
		</Container>
	);
};

const Container = styled.div`
	margin: 0 ${props => props.theme.size.static200};
`;
